import * as Yup from "yup"

import {AssetType, ContractType, PositionType, SearchMatchRequest, SwitchEnum, SwitchUtils,} from "models"
import {CreateResearchRequest} from "../../../../models/priorities";

export class DashboardMapPrioritiesSearchForm
{
	savedSearch: string|null|"" = ""
	saveResearch: boolean = false

	name: string | null = ""
	brandId: string = ""
	region?: string | null = ""
	city?: string | null = ""
	street?: string | null = ""
	priorityLevel: "URGENTE" | "ALTA" | "NORMALE" | "BASSA" = "NORMALE"
	preferredContractType?: ContractType | string | null = ""
	positionType?: PositionType | string | null = ""
	maxPrice?: number | string | null = ""
	airConditioning?: SwitchEnum = SwitchEnum.UNINTERESTING
	shopWindows?: SwitchEnum = SwitchEnum.UNINTERESTING
	parkingSlots?: SwitchEnum = SwitchEnum.UNINTERESTING
	singleLevel?: SwitchEnum = SwitchEnum.UNINTERESTING
	minDim?: number | string | null = ""
	maxDim?: number | string | null = ""
	propertyType?: AssetType|null = null

	public static fromServerResponse(response: any, brandId: string): DashboardMapPrioritiesSearchForm {
		const form = new DashboardMapPrioritiesSearchForm()

		if(response){
			form.savedSearch = response.id
			form.name = response.name
			form.region = response.region
			form.city = response.city
			form.street = response.zone
			form.priorityLevel = "NORMALE"
			form.brandId = brandId

			if(response.requisiteOverrides){
				form.positionType = response.requisiteOverrides.positionType as string
				form.preferredContractType = Object.entries(response.requisiteOverrides.preferredContractTypes)
					.filter(([_, v]) => v === true)
					.map(([k, _]) => k)[0]
				form.shopWindows = SwitchUtils.setSelectValue(response.requisiteOverrides.shopWindows)
				form.singleLevel = SwitchUtils.setSelectValue(response.requisiteOverrides.singleLevel)
				form.airConditioning = SwitchUtils.setSelectValue(response.requisiteOverrides.airConditioning)
				form.parkingSlots = SwitchUtils.setSelectValue(response.requisiteOverrides.parkingSlots)
				form.minDim = response.requisiteOverrides.minGla ?? response.requisiteOverrides.minLandArea
				form.maxDim = response.requisiteOverrides.maxGla ?? response.requisiteOverrides.maxLandArea
				form.maxPrice = response.requisiteOverrides.maxPrice
				form.propertyType = response.requisiteOverrides.preferredAssetType ?? null
			}
			else {
				form.positionType = null
				form.preferredContractType = null
				form.shopWindows = SwitchUtils.setSelectValue(null)
				form.singleLevel = SwitchUtils.setSelectValue(null)
				form.airConditioning = SwitchUtils.setSelectValue(null)
				form.parkingSlots = SwitchUtils.setSelectValue(null)
				form.minDim = null
				form.maxDim = null
				form.maxPrice = null
				form.propertyType = null
			}
		}
		return form
	}

	public static getCreateRequest(values: any, brandId: string): CreateResearchRequest | null {
		let request: CreateResearchRequest | null = null

		const enumValues = Object.values(ContractType)
		const contracts: Record<string, boolean> = {}

		enumValues.forEach((enumValue) => {
			contracts[enumValue] = values.preferredContractTypes?.includes(enumValue)
		})


		if(values){
			request = {
				name: values.name,
				brandId: brandId,
				region: values.region !== undefined  && values.region !== "" ? values.region : null,
				city: values.city !== undefined && values.city !== ""? values.city : null,
				street: values.street !== undefined && values.street !== ""? values.street : null,
				priorityLevel: "NORMALE",
				preferredContractTypes: contracts,
				positionType: values.positionType !== undefined  && values.positionType !== ""? values.positionType : null,
				airConditioning: values.airConditioning !== undefined ? SwitchUtils.setSwitchValue(values.airConditioning) : null,
				shopWindows: values.shopWindows !== undefined ? SwitchUtils.setSwitchValue(values.shopWindows) : null,
				parkingSlots: values.parkingSlots !== undefined ? SwitchUtils.setSwitchValue(values.parkingSlots) : null,
				singleLevel: values.singleLevel !== undefined ? SwitchUtils.setSwitchValue(values.singleLevel) : null,
				minDim: values.minDim !== undefined && values.minDim !== ""? values.minDim : null,
				maxDim: values.maxDim !== undefined && values.maxDim !== ""? values.maxDim : null,
				maxPrice: values.maxPrice !== undefined && values.maxPrice !== "" ? values.maxPrice : null,
				propertyType: values.propertyType
			}
		}
		return request
	}

	public static getSearchRequest (values: any): SearchMatchRequest | null {
		let request: SearchMatchRequest | null = null

		if(values){
			request = {
				pageSize: 50,
				pageId: 0,
				orderType: null,
				orderBy: null,
				name: values.name ?? "Ricerca senza nome",
				region: values.region !== undefined  && values.region !== "" ? values.region : null,
				place: values.city !== undefined && values.city !== ""? values.city : null,
				street: values.street !== undefined && values.street !== ""? values.street : null,
				positionType: values.positionType !== undefined && values.positionType !== "" ? values.positionType : null,
				assetType: values.propertyType !== undefined && values.propertyType !== "" ? values.propertyType : null,
				contractType: values.preferredContractTypes !== undefined && values.preferredContractTypes !== "" ? values.preferredContractTypes : null,
				maxGla: values.maxDim !== undefined && values.maxDim !== "" ? values.maxDim : null,
				minGla: values.minDim !== undefined && values.minDim !== "" ? values.minDim : null,
				maxPrice: values.maxPrice !== undefined ? values.maxPrice : null,
				shopWindows: SwitchUtils.setSwitchValue(values.shopWindows),
				airConditioning: SwitchUtils.setSwitchValue(values.airConditioning),
				parkingSlots: SwitchUtils.setSwitchValue(values.parkingSlots),
				singleLevel: SwitchUtils.setSwitchValue(values.singleLevel),
			}
		}

		return request
	}

}

const DashboardMapPrioritiesSearchValidation = {
	maxPrice: Yup.number()
		.moreThan(-1)
		.nullable()
		.transform((v, o) => o === '' ? null : v)
		.notRequired(),
	region: Yup.string().when("saveResearch", {
		is: true,
		then: (schema: any) => Yup.string().required("Il campo è obbligatorio")
	}),
	name: Yup.string().when("saveResearch", {
		is: true,
		then: (schema: any) => Yup.string().required("Il campo è obbligatorio")
	})
}

export default Yup.object()
	.shape(
		DashboardMapPrioritiesSearchValidation,
	)
	.required()
